import React from "react";
import Navbar from "../Navbar";
import Issue from "../category/Issue";
import MobileNav from "./MobileNav";
import ScreenNav from "./ScreenNav";
import Comments from "../category/Comments";
import BookingConfirmed from './BookingConfirmed';
import YourDevice from "../category/YourDevice";
import { useNavigate, useLocation } from "react-router-dom";

const Integration = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { brandName, modelName, name, description, imageUrl } = location.state || {};
  
  const Title1 = brandName || "apple";
  const categoryName = sessionStorage.getItem('categoryName');
  let Type = categoryName
  const Brand = brandName || "apple";
  const Model = modelName || "iphone";
  const Title2 = name || "apple";
  const Description2 = description;

  const handleChange = () => {
    navigate("/defects", { state: { ...location.state } });
  };

  const handlePhoneChange = () => {
    navigate("/category", { state: { ...location.state } });
  };

  return (
    <div className="bg-grSilver">
      <Navbar />
      <div className="sm:pr-[36px] px-[24px] items-center justify-center gap-[50px] flex flex-col pb-[90px] mt-8 sm:mt-[60px]">
        <div className="flex lg:flex-row flex-col xl:gap-[300px]" style={{overflowX:'hidden'}}>
          <div className="lg:hidden block self-center">
            <MobileNav />
          </div>
          <div className="flex-grow lg:max-w-auto pl-2 mr-6">
            <BookingConfirmed />
          </div>
          <div className="flex lg:justify-center justify-start lg:border-l-[2px] border-t-[2px] lg:border-t-[0px]">
            <div className="flex flex-col gap-[30px] lg:ml-5">
              <div className="hidden lg:block">
                <ScreenNav />
              </div>
              <div className="flex flex-col gap-[10px] border-b-[1px] sm:h-[140px] h-[160px] mb-24 ml-3" style={{maxWidth:'90%'}}>
                <div className="flex flex-row justify-between sm:ml-12 lg:ml-0 mt-4">
                  <p className="text-[#475467] font-[700] text-[14px] leading-[20px] font-grFont self-start">
                    Your Device
                  </p>
                </div>
                <YourDevice
                  phone={Title1}
                  type={Type}
                  Brand={Brand}
                  Model={Model}
                />
                <div className="flex flex-row justify-between sm:mt-3 mt-6 sm:pt-0 pt-6">
                  <p className="text-[#475467] font-[700] text-[14px] leading-[20px] font-grFont self-start">
                    Your Issue
                  </p>

                </div>
                <Issue
                  title={Title2}
                  description={Description2}
                  icon={imageUrl}
                />
              </div>
              <div className="mt-16">
                <Comments />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Integration;
